const emptyRow = () => ({ question: "", answer: "" });

const Faq = ({ form, setForm }) => {
  const rows: any[] = form?.faqs || [];

  const update = (index: number, field: string, value: string) => {
    setForm((prev) => {
      const next = [...(prev.faqs || [])];
      next[index] = { ...next[index], [field]: value };
      return { ...prev, faqs: next };
    });
  };

  const add = () => {
    setForm((prev) => ({
      ...prev,
      faqs: [...(prev.faqs || []), emptyRow()],
    }));
  };

  const remove = (index: number) => {
    setForm((prev) => {
      const next = [...(prev.faqs || [])];
      next.splice(index, 1);
      return { ...prev, faqs: next };
    });
  };

  return (
    <div className="AddInfoContainer">
      {rows.map((row, index) => (
        <section
          key={index}
          className={`addProductInfo ${index % 2 !== 0 ? "backGround" : ""}`}
        >
          <div className="selectorContainer">
            <span className="input3" style={{ flex: 2 }}>
              <label className="sideBarTitle">سوال</label>
              <input
                className="selector1"
                value={row.question}
                onChange={(e) => update(index, "question", e.target.value)}
              />
            </span>
            <span className="input3" style={{ flex: 3 }}>
              <label className="sideBarTitle">جواب</label>
              <textarea
                className="selector1"
                rows={3}
                value={row.answer}
                onChange={(e) => update(index, "answer", e.target.value)}
              />
            </span>
            <span className="input3" style={{ display: "flex", alignItems: "flex-end" }}>
              <button
                className="dashboardHeader"
                style={{ background: "#e53e3e" }}
                onClick={() => remove(index)}
              >
                <p>حذف</p>
              </button>
            </span>
          </div>
        </section>
      ))}
      <button className="dashboardHeader" style={{ marginTop: 16 }} onClick={add}>
        <p>+ افزودن سوال</p>
      </button>
    </div>
  );
};

export default Faq;
